import { configureStore } from '@reduxjs/toolkit'

import partTableReducer from './partTableSlice'

const store = configureStore({
  reducer: {
    // Define a top-level state field named `todos`, handled by `todosReducer`
    partTable: partTableReducer,
  }
})

export default store